import React from 'react'
import { ReactComponent as BoltIcon } from 'assets/icons/bolt.svg'
import { ReactComponent as ArrowIcon } from 'assets/icons/arrow_short_right.svg'
import s from './styles/KodaInsightCard.module.scss'

const KodaInsightCard = ({ insight, onAction }) => {
	if (!insight) return null
	const ctaLabel = insight.ctaLabel || 'Take action'

	return (
		<article className={s.card} onClick={onAction}>
			<div className={s.inner}>
				<span className={s.iconWrap}>
					<BoltIcon className={s.icon} />
				</span>

				<h3 className={s.title}>{insight.title}</h3>
			</div>
			{insight.description ? (
				<p className={s.description}>{insight.description}</p>
			) : null}

			<button type="button" className={s.cta}>
				<span>{ctaLabel}</span>
				<ArrowIcon className={s.ctaIcon} />
			</button>
		</article>
	)
}

export default KodaInsightCard
